import api from "api";

// Nome diferente de `api/requests/campaigns.js` (relatório de atribuição
// UTM) para não colidir — são duas features de "campanha" sem relação.
const emailCampaigns = {
    create: (payload) => {
        return api().post('/producer-profiles/me/email-campaigns', payload);
    },

    list: (params) => {
        return api().get('/producer-profiles/me/email-campaigns', { params });
    },

    get: (id) => {
        return api().get(`/producer-profiles/me/email-campaigns/${id}`);
    },

    getRecipients: (id, params) => {
        return api().get(`/producer-profiles/me/email-campaigns/${id}/recipients`, { params });
    },

    getAudienceCount: (params) => {
        return api().get('/producer-profiles/me/email-campaigns/audience-count', { params });
    },

    cancel: (id) => {
        return api().post(`/producer-profiles/me/email-campaigns/${id}/cancel`);
    },
};

export default emailCampaigns;
